export const cacheKeys = {
  getMajor: 'getMajor',
  getMajors: 'getMajors',
  likeMajor: 'likeMajor',
  unlikeMajor: 'unlikeMajor',
  ignoreMajor: 'ignoreMajor',
};
